// @flow
import { sum, toString } from 'lodash/fp';
import round from 'lodash/round';
import { Player } from './types';

const normalisePlayer: Player = (player, { isGolf }) => {
  const isTeam = `${player.DraftstarsID}`.includes('T');
  const insiderScore = round(player['raw-DraftStars'], 1);
  const salary = player.DSSalary;
  const insiderId = isTeam ? player.DraftstarsID : toString(parseInt(player.DraftstarsID, 10));

  let last5 = [];
  try {
    last5 = Array.isArray(player.Last5DS) ? player.Last5DS : JSON.parse(player.Last5DS);
  } catch (err) {
    // console.log(err);
  }

  return {
    insiderId,
    insiderIdStr: isTeam ? `TEAM_${insiderId.replace('T', '')}` : `PLAYER_${insiderId}`,
    insiderName: player.Player,
    insiderPosition: player.DSPosition,
    insiderPosition2: player.DSPosition2,
    insiderStdDev: player.DSSD || insiderScore * 0.4,
    insiderSalary: salary,
    insiderStatus: player.playingStatus,
    insiderTeam: player.Team,
    insiderForm:
      Array.isArray(last5) && last5.length > 0
        ? round(sum(last5) / last5.length, 1)
        : round(parseFloat(player.Last5DS), 1),
    insiderGames: player.Games,
    insiderOpponent: player.Opponent,
    insiderScore,
    insiderScoreUpdated: insiderScore,
    insiderSalaryScoreRatio: insiderScore !== 0 ? round(salary / insiderScore) : 0,
    insiderLastUpdatedAt: player.lastUpdated,
    insiderWarning: player.Games < 10 && !isGolf,
    insiderLow100s: player['100s'] <= 0,
    isTeam
  };
};

export default normalisePlayer;
